import { motion } from "framer-motion";

const container = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.09 } },
};

const line = {
  hidden: { y: "110%" },
  visible: { y: "0%", transition: { duration: 0.9, ease: [0.16, 1, 0.3, 1] } },
};

export const TextReveal = ({ text, as = "span", className = "", delay = 0 }) => {
  const words = text.split(" ");
  const Tag = as;
  return (
    <Tag className={className}>
      {words.map((word, i) => (
        <span key={`${word}-${i}`} style={{ display: "inline-block", overflow: "hidden", verticalAlign: "top" }}>
          <motion.span
            style={{ display: "inline-block" }}
            initial="hidden"
            animate="visible"
            variants={line}
            transition={{ delay: delay + i * 0.06 }}
          >
            {word}
            {i !== words.length - 1 ? "\u00A0" : ""}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
};
